module.exports = __webpack_public_path__ + "img/logo.07cd4d32.png";